/* NODRYZA — interacciones de las secciones nz-* */
(function () {
  'use strict';

  /* Este archivo lo incluye CADA sección nz-*, así que en una ficha con 7
     secciones el navegador lo ejecutaba 7 veces y ataba 7 veces cada listener:
     el botón "+" de cantidad sumaba de 7 en 7 (1 → 8 → 15). Con este candado
     solo se ejecuta la primera vez. */
  if (window.__nzCodigoCargado) return;
  window.__nzCodigoCargado = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- animaciones de entrada (un solo observer compartido) ----
     Red de seguridad: si el observador no responde (navegadores raros,
     ventanas en segundo plano), a los 2 s se muestra todo igualmente. */
  function initReveals() {
    var elementos = document.querySelectorAll('.nz-reveal');
    if (!elementos.length) return;

    function mostrarTodo() {
      elementos.forEach(function (el) { el.classList.add('nz-visible'); });
    }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      mostrarTodo();
      return;
    }

    var funciono = false;
    var observer = new IntersectionObserver(function (entradas) {
      funciono = true;
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('nz-visible');
          observer.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    elementos.forEach(function (el) { observer.observe(el); });

    setTimeout(function () {
      if (!funciono) {
        observer.disconnect();
        mostrarTodo();
      }
    }, 2000);
  }

  /* ---- cifras animadas (count-up) ---- */
  function initCountUp() {
    var cifras = document.querySelectorAll('[data-nz-countup]');
    if (!cifras.length) return;

    function animar(el) {
      var texto = el.getAttribute('data-nz-countup');
      var match = texto.match(/([\d.,]+)/);
      if (!match || reduceMotion) { el.textContent = texto; return; }
      var crudo = match[1];
      var objetivo = parseFloat(crudo.replace(/\./g, '').replace(',', '.'));
      if (isNaN(objetivo)) { el.textContent = texto; return; }
      var decimales = (crudo.split(',')[1] || '').length;
      var usaMiles = crudo.indexOf('.') > -1;
      var inicio = null;
      var duracion = 1400;

      function formatear(valor) {
        var s = valor.toFixed(decimales).replace('.', ',');
        if (usaMiles) {
          var partes = s.split(',');
          partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          s = partes.join(',');
        }
        return texto.replace(match[1], s);
      }

      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var suavizado = 1 - Math.pow(1 - progreso, 3);
        el.textContent = formatear(objetivo * suavizado);
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      cifras.forEach(function (el) { el.textContent = el.getAttribute('data-nz-countup'); });
      return;
    }
    var funciono = false;
    var pendientes = [];
    var observer = new IntersectionObserver(function (entradas) {
      funciono = true;
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          animar(entrada.target);
          observer.unobserve(entrada.target);
          var idx = pendientes.indexOf(entrada.target);
          if (idx > -1) pendientes.splice(idx, 1);
        }
      });
    }, { threshold: 0.4 });
    cifras.forEach(function (el) { pendientes.push(el); observer.observe(el); });
    setTimeout(function () {
      if (!funciono) {
        observer.disconnect();
        pendientes.forEach(function (el) { el.textContent = el.getAttribute('data-nz-countup'); });
      }
    }, 2000);
  }

  /* ---- galería de producto ---- */
  function initGaleria() {
    var galeria = document.querySelector('[data-nz-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-nz-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-nz-mini]');
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var url = mini.getAttribute('data-nz-mini');
        if (!url || principal.getAttribute('src') === url) return;
        principal.classList.add('nz-cambiando');
        setTimeout(function () {
          principal.setAttribute('src', url);
          principal.setAttribute('srcset', '');
          principal.onload = function () { principal.classList.remove('nz-cambiando'); };
        }, 150);
        minis.forEach(function (m) { m.classList.remove('nz-activa'); });
        mini.classList.add('nz-activa');
      });
    });
  }

  /* ---- selector de cantidad ---- */
  function initCantidad() {
    document.querySelectorAll('[data-nz-cantidad]').forEach(function (caja) {
      var input = caja.querySelector('input');
      var menos = caja.querySelector('[data-nz-menos]');
      var mas = caja.querySelector('[data-nz-mas]');
      if (!input || !menos || !mas) return;
      /* avisar del cambio: el selector de packs y la barra fija de compra
         se apoyan en este evento para no quedarse con un dato viejo */
      function avisar() {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      menos.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        avisar();
      });
      mas.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        avisar();
      });
    });
  }

  /* ---- variantes: actualizar id, precio y disponibilidad ---- */
  function initVariantes() {
    var seccion = document.querySelector('[data-nz-producto]');
    if (!seccion) return;
    var datos = seccion.querySelector('[data-nz-variantes-json]');
    var selectorForm = seccion.querySelector('[data-nz-variantes]');
    if (!datos || !selectorForm) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }

    var inputId = seccion.querySelector('input[name="id"]');
    var precioEl = seccion.querySelector('[data-nz-precio]');
    var precioAntesEl = seccion.querySelector('[data-nz-precio-antes]');
    var boton = seccion.querySelector('[data-nz-boton-compra]');
    var moneda = seccion.getAttribute('data-nz-moneda') || 'EUR';

    function formatearDinero(centimos) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'es', {
          style: 'currency', currency: moneda
        }).format(centimos / 100);
      } catch (e) {
        return (centimos / 100).toFixed(2) + ' ' + moneda;
      }
    }

    function actualizar() {
      var elegidas = [];
      selectorForm.querySelectorAll('[data-nz-opcion]').forEach(function (grupo) {
        var marcada = grupo.querySelector('input:checked');
        elegidas.push(marcada ? marcada.value : null);
      });
      var variante = variantes.find(function (v) {
        return elegidas.every(function (valor, i) { return v.options[i] === valor; });
      });
      if (!variante) {
        if (boton) { boton.disabled = true; boton.textContent = boton.getAttribute('data-texto-nodisponible') || 'No disponible'; }
        return;
      }
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatearDinero(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatearDinero(variante.compare_at_price);
          precioAntesEl.hidden = false;
        } else {
          precioAntesEl.hidden = true;
        }
      }
      if (boton) {
        boton.disabled = !variante.available;
        boton.textContent = variante.available
          ? (boton.getAttribute('data-texto-comprar') || boton.textContent)
          : (boton.getAttribute('data-texto-agotado') || 'Agotado');
      }
    }

    selectorForm.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', actualizar);
    });
    actualizar();
  }

  /* ---- barra fija de compra en móvil ---- */
  function initBarraFija() {
    var barra = document.querySelector('[data-nz-barra-fija]');
    var referencia = document.querySelector('[data-nz-boton-compra]');
    if (!barra || !referencia) return;

    /* la clase va también en <html>: mientras la barra de compra está arriba,
       la barra de iconos del tema (.kalles_toolbar) se esconde. Si no, se
       pisan — la del tema va por encima y tapa el botón de añadir */
    var raiz = document.documentElement;
    function marcarVisible(visible) {
      barra.classList.toggle('nz-barra-visible', visible);
      raiz.classList.toggle('nz-con-barra', visible);
    }

    var usarScroll = !('IntersectionObserver' in window);

    if (!usarScroll) {
      var funciono = false;
      var observer = new IntersectionObserver(function (entradas) {
        funciono = true;
        entradas.forEach(function (entrada) {
          marcarVisible(!entrada.isIntersecting && entrada.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      observer.observe(referencia);
      setTimeout(function () {
        if (!funciono) {
          observer.disconnect();
          activarPorScroll();
        }
      }, 2000);
    } else {
      activarPorScroll();
    }

    function activarPorScroll() {
      var esperando = false;
      function comprobar() {
        esperando = false;
        marcarVisible(referencia.getBoundingClientRect().bottom < 0);
      }
      window.addEventListener('scroll', function () {
        if (!esperando) {
          esperando = true;
          requestAnimationFrame(comprobar);
        }
      }, { passive: true });
      comprobar();
    }

    var formProducto = document.querySelector('[data-nz-producto] form[data-nz-form]');

    var botonBarra = barra.querySelector('[data-nz-barra-boton]');
    if (botonBarra) {
      botonBarra.addEventListener('click', function () {
        if (formProducto) {
          if (typeof formProducto.requestSubmit === 'function') formProducto.requestSubmit();
          else formProducto.submit();
        }
      });
    }

    /* El botón de la barra NO añade una unidad: envía el formulario de la
       ficha, que viene con el pack preseleccionado. Así que la barra tiene que
       enseñar las unidades y el precio que se van a cobrar de verdad; si dice
       44,95 € y mete 2 uds, el cliente se encuentra 69,95 € en el carrito. */
    var precioBarra = barra.querySelector('.nz-barra-fija__precio');
    var cantidad = formProducto && formProducto.querySelector('input[name="quantity"]');
    var cajaPacks = document.querySelector('[data-nz-packs]');
    if (!precioBarra || !cantidad) return;

    var precioUnidad = precioBarra.textContent.trim();

    function sincronizarPrecioBarra() {
      var unidades = parseInt(cantidad.value, 10) || 1;
      if (unidades < 2) {
        precioBarra.textContent = precioUnidad;
        return;
      }
      var opcion = cajaPacks && cajaPacks.querySelector('input[data-nz-pack][value="' + unidades + '"]');
      var etiqueta = opcion && opcion.closest('.nz-packs__opcion').querySelector('.nz-packs__precio');
      /* si esa cantidad no es ninguno de los packs (4, 5...) se enseñan solo
         las unidades: calcular el importe aquí sería duplicar los descuentos
         automáticos de Shopify y acabaríamos enseñando un precio que no es */
      precioBarra.textContent = etiqueta
        ? unidades + ' uds · ' + etiqueta.textContent.trim()
        : unidades + ' uds';
    }

    cantidad.addEventListener('change', sincronizarPrecioBarra);
    cantidad.addEventListener('input', sincronizarPrecioBarra);
    if (cajaPacks) {
      cajaPacks.addEventListener('change', function () { setTimeout(sincronizarPrecioBarra, 0); });
    }
    sincronizarPrecioBarra();
  }

  /* ---- desplazamiento suave para enlaces internos de las secciones ---- */
  function initAnclas() {
    document.querySelectorAll('[data-nz-ancla]').forEach(function (enlace) {
      enlace.addEventListener('click', function (e) {
        var destino = document.querySelector(enlace.getAttribute('href'));
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---- botón "volver a la compra" ---- */
  function initIrACompra() {
    document.querySelectorAll('[data-nz-ir-compra]').forEach(function (enlace) {
      enlace.addEventListener('click', function (e) {
        e.preventDefault();
        var destino = document.querySelector('[data-nz-producto]') || document.body;
        destino.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    initReveals();
    initIrACompra();
    initCountUp();
    initGaleria();
    initCantidad();
    initVariantes();
    initBarraFija();
    initAnclas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
